module.exports = __webpack_public_path__ + "img/super_wild_win_special_skill.f5c1c1db.png";